import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IState from '@/interfaces/IState';
import { extractFullData } from '@/libs/backend/apimapper';
import { ActionContext } from 'vuex';

export default async (context: ActionContext<IState, IState>, payload: IPayloadQuery = {}) => {
    const { query, metaData } = payload;
    try {
        const {data} = await context.dispatch('backendTalker', {
            request: 'subscriptions_client_apps_list',
            query
        });
        
        if (metaData) {
            return query && query.includes('pagination=true') ? extractFullData(data) : data;
        }
        else {
            context.commit('clientAppsUpload', data);
        }
        
    } catch (err) {
        return Promise.reject(err);
    }
};
